import { Link } from "react-router-dom"
import Section from "components/layout/section"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import { useTranslation } from "react-i18next"
import PageTitle from "features/navigation/pageTitle"
import RightSidebar from "@/components/sidebar/right/RightSidebar"
import Hint from "@/components/text/Hint"
import { ReactComponent as SearchIcon } from "assets/icons/search.svg"
import { ReactComponent as ChevronRightIcon } from "assets/icons/chevron_right.svg"

const TutorialsPage = () => {
    const { t } = useTranslation()

    return (
        <>
            <PageTitle title={t("titleTutorials")} />
            <Section>
                <p>{t("tutorialsIntro")}</p>
                <Hint>{t("tutorialsHint")}</Hint>
            </Section>
            <Section>
                <Link
                    to="/tutorials/search"
                    className="flex flex-row items-center gap-x-1 min-h-[26px] rounded-md bg-gray-100 p-2 hover:bg-blue-100"
                >
                    <SearchIcon className="h-6 w-6 shrink-0 fill-blue-500" />
                    <span className="flex min-w-0 flex-1 flex-col gap-y-1">
                        <span className="text-blue-500 select-none">{t("tutorialSearchTitle")}</span>
                        <span className="text-sm text-gray-500">{t("tutorialSearchSummary")}</span>
                    </span>
                    <ChevronRightIcon className="h-6 w-6 shrink-0 fill-blue-500" />
                </Link>
            </Section>
            <RightSidebar />
        </>
    )
}

export default TutorialsPage
